import React, { Component } from "react";
import axios from "axios";

export class Step8Review extends Component {
  constructor(props) {
  super(props);

  this.state = {
    loading: false,
  };
}
  renderArray = (data) => {
    if (!data || data.length === 0) return "-";
    return Array.isArray(data) ? data.join(", ") : data;
  };

handleSubmit = async () => {
  const data = this.props.formData;

  const formData = new FormData();

  // Upload Attachment
  if (data.attachment) {
    formData.append("imageUpload[]", data.attachment);
  }

  // Business Information
  formData.append("company_name", data.ownerName || "");
  formData.append("company_business_name", data.businessName || "");
  formData.append("company_business_type", data.businessCategory || "");
  formData.append("company_email", data.email || "");
  formData.append("company_mobile", data.mobile || "");
  formData.append("company_whatsapp", data.whatsapp || "");
  formData.append("company_city", data.city || "");
  formData.append("company_state", data.state || "");
  formData.append("company_address", data.address || "");

  formData.append(
    "company_services",
    Array.isArray(data.services)
      ? data.services.join(",")
      : (data.services || "")
  );

  // Website
  formData.append("company_website_type", data.websiteType || "");
  formData.append("company_website_pages", data.pages || "");
  formData.append("company_website_domain", data.domain || "No");
  formData.append("company_website_hosting", data.hosting || "No");
  formData.append("company_website_admin_panel", data.adminPanel || "No");
  formData.append("company_website_login_system", data.loginSystem || "No");
  formData.append("company_website_payment_gateway", data.paymentGateway || "No");
  formData.append("company_website_seo", data.seo || "No");
  formData.append("company_website_description", data.description || "");

  // Mobile
  formData.append("company_mobile_platform", data.platform || "");
  formData.append("company_mobile_type", data.appType || "");
  formData.append("company_mobile_admin_panel", data.adminPanel || "No");
  formData.append("company_mobile_login_system", data.userLogin || "No");
  formData.append("company_mobile_payment_gateway", data.paymentGateway || "No");
  formData.append("company_mobile_push_notification", data.pushNotification || "No");
  formData.append("company_mobile_description", data.mobileDescription || "");

  // Marketing
  formData.append(
    "company_marketing_services",
    Array.isArray(data.marketingServices)
      ? data.marketingServices.join(",")
      : (data.marketingServices || "")
  );
  formData.append("company_marketing_budget", data.monthlyBudget || "");
  formData.append("company_marketing_duration", data.campaignDuration || "");
  formData.append("company_marketing_location", data.targetLocation || "");
  formData.append("company_marketing_description", data.goals || "");

  // Software
  formData.append("company_software_type", data.softwareType || "");
  formData.append("company_software_users", data.users || "");
  formData.append(
    "company_software_modules",
    Array.isArray(data.modules)
      ? data.modules.join(",")
      : (data.modules || "")
  );
  formData.append("company_software_admin_panel", data.cloudHosting || "No");
  formData.append("company_software_reports", data.reports || "No");
  formData.append("company_software_description", data.softwareDescription || "");

  // Project
  formData.append("company_project_title", "");
  formData.append("company_project_budget", data.expectedBudget || "");
  formData.append("company_project_deadline", data.expectedDelivery || "");
  formData.append("company_reference_website", data.referenceWebsite || "");
  formData.append(
    "company_additional_requirement",
    data.additionalRequirement || ""
  );
  this.setState({
    loading: true,
  });

  try {

    const response = await axios.post(
      "https://idealtechnoride.in/api/main/add/company_costing",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response.data);

    if (
  response.data.status === 1 ||
  response.data.status === "1" ||
  response.data.status === true
) {
  this.setState({ loading: false });

  this.props.resetForm(
    response.data.message || "Request Submitted Successfully."
  );
} else {
  this.setState({ loading: false });

  alert(response.data.message || response.data || "Submission Failed");
}

  } catch (error) {
    console.error(error);

    if (error.response) {
      console.log(error.response.data);
    }

    this.setState({ loading: false });

    alert("Server Error");
  }
};

    
  render() {
    const data = this.props.formData;

    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 8 : Review & Submit
            </h3>
          </div>

          <div className="card-body">

            <div className="alert alert-info">
              Please review your information before submitting.
            </div>

            {/* Business Information */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0">Business Information</h5>
              </div>

              <div className="card-body">

                <table className="table table-bordered">
                  <tbody>

                    <tr>
                      <th width="35%">Business Name</th>
                      <td>{data.businessName || "-"}</td>
                    </tr>

                    <tr>
                      <th>Owner Name</th>
                      <td>{data.ownerName || "-"}</td>
                    </tr>

                    <tr>
                      <th>Mobile Number</th>
                      <td>{data.mobile || "-"}</td>
                    </tr>

                    <tr>
                      <th>WhatsApp Number</th>
                      <td>{data.whatsapp || "-"}</td>
                    </tr>

                    <tr>
                      <th>Email</th>
                      <td>{data.email || "-"}</td>
                    </tr>

                    <tr>
                      <th>Business Category</th>
                      <td>{data.businessCategory || "-"}</td>
                    </tr>

                    <tr>
                      <th>Address</th>
                      <td>{data.address || "-"}</td>
                    </tr>

                    <tr>
                      <th>City</th>
                      <td>{data.city || "-"}</td>
                    </tr>

                    <tr>
                      <th>State</th>
                      <td>{data.state || "-"}</td>
                    </tr>

                  </tbody>
                </table>

              </div>
            </div>

            {/* Services */}
            <div className="card mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0">Selected Services</h5>
              </div>

              <div className="card-body">
                <p>{this.renderArray(data.services)}</p>
              </div>
            </div>

            {/* Website */}
            {data.websiteType && (
              <div className="card mb-4">

                <div className="card-header bg-light">
                  <h5 className="mb-0">Website Requirements</h5>
                </div>

                <div className="card-body">

                  <table className="table table-bordered">
                    <tbody>

                      <tr>
                        <th width="35%">Website Type</th>
                        <td>{data.websiteType}</td>
                      </tr>

                      <tr>
                        <th>Pages</th>
                        <td>{data.pages}</td>
                      </tr>

                      <tr>
                        <th>Domain Required</th>
                        <td>{data.domain}</td>
                      </tr>

                      <tr>
                        <th>Hosting Required</th>
                        <td>{data.hosting}</td>
                      </tr>

                      <tr>
                        <th>Admin Panel</th>
                        <td>{data.adminPanel}</td>
                      </tr>

                      <tr>
                        <th>User Login</th>
                        <td>{data.loginSystem}</td>
                      </tr>

                      <tr>
                        <th>Payment Gateway</th>
                        <td>{data.paymentGateway}</td>
                      </tr>

                      <tr>
                        <th>SEO</th>
                        <td>{data.seo}</td>
                      </tr>

                      <tr>
                        <th>Description</th>
                        <td>{data.description}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            )}

            {/* Mobile */}
            {data.appType && (
              <div className="card mb-4">

                <div className="card-header bg-light">
                  <h5 className="mb-0">Mobile App Requirements</h5>
                </div>

                <div className="card-body">

                  <table className="table table-bordered">
                    <tbody>

                      <tr>
                        <th width="35%">App Type</th>
                        <td>{data.appType}</td>
                      </tr>

                      <tr>
                        <th>Platform</th>
                        <td>{data.platform}</td>
                      </tr>

                      <tr>
                        <th>User Login</th>
                        <td>{data.userLogin}</td>
                      </tr>

                      <tr>
                        <th>Admin Panel</th>
                        <td>{data.adminPanel}</td>
                      </tr>

                      <tr>
                        <th>Payment Gateway</th>
                        <td>{data.paymentGateway}</td>
                      </tr>

                      <tr>
                        <th>Push Notification</th>
                        <td>{data.pushNotification}</td>
                      </tr>

                      <tr>
                        <th>GPS</th>
                        <td>{data.gpsLocation}</td>
                      </tr>

                      <tr>
                        <th>Chat Support</th>
                        <td>{data.chatSupport}</td>
                      </tr>

                      <tr>
                        <th>API Integration</th>
                        <td>{data.apiIntegration}</td>
                      </tr>

                      <tr>
                        <th>Description</th>
                        <td>{data.mobileDescription}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            )}

            {/* Marketing */}
            {data.marketingServices && (
              <div className="card mb-4">

                <div className="card-header bg-light">
                  <h5 className="mb-0">Digital Marketing</h5>
                </div>

                <div className="card-body">

                  <table className="table table-bordered">
                    <tbody>

                      <tr>
                        <th width="35%">Services</th>
                        <td>{this.renderArray(data.marketingServices)}</td>
                      </tr>

                      <tr>
                        <th>Website</th>
                        <td>{data.businessWebsite}</td>
                      </tr>

                      <tr>
                        <th>Social Platforms</th>
                        <td>{this.renderArray(data.socialPlatforms)}</td>
                      </tr>

                      <tr>
                        <th>Budget</th>
                        <td>{data.monthlyBudget}</td>
                      </tr>

                      <tr>
                        <th>Campaign Duration</th>
                        <td>{data.campaignDuration}</td>
                      </tr>

                      <tr>
                        <th>Target Location</th>
                        <td>{data.targetLocation}</td>
                      </tr>

                      <tr>
                        <th>Target Audience</th>
                        <td>{data.targetAudience}</td>
                      </tr>

                      <tr>
                        <th>Goals</th>
                        <td>{data.goals}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            )}

            {/* Software */}
            {data.softwareType && (
              <div className="card mb-4">

                <div className="card-header bg-light">
                  <h5 className="mb-0">Software Requirements</h5>
                </div>

                <div className="card-body">

                  <table className="table table-bordered">
                    <tbody>

                      <tr>
                        <th width="35%">Software Type</th>
                        <td>{data.softwareType}</td>
                      </tr>

                      <tr>
                        <th>Platform</th>
                        <td>{data.platform}</td>
                      </tr>

                      <tr>
                        <th>Expected Users</th>
                        <td>{data.users}</td>
                      </tr>

                      <tr>
                        <th>Modules</th>
                        <td>{this.renderArray(data.modules)}</td>
                      </tr>

                      <tr>
                        <th>Cloud Hosting</th>
                        <td>{data.cloudHosting}</td>
                      </tr>

                      <tr>
                        <th>Reports</th>
                        <td>{data.reports}</td>
                      </tr>

                      <tr>
                        <th>Description</th>
                        <td>{data.softwareDescription}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            )}

            {/* Additional Requirements */}
            <div className="card mb-4">

              <div className="card-header bg-light">
                <h5 className="mb-0">Additional Requirements</h5>
              </div>

              <div className="card-body">

                <table className="table table-bordered">
                  <tbody>

                    <tr>
                      <th width="35%">Expected Budget</th>
                      <td>{data.expectedBudget || "-"}</td>
                    </tr>

                    <tr>
                      <th>Project Start Date</th>
                      <td>{data.expectedStartDate || "-"}</td>
                    </tr>

                    <tr>
                      <th>Expected Delivery</th>
                      <td>{data.expectedDelivery || "-"}</td>
                    </tr>

                    <tr>
                      <th>Reference Website</th>
                      <td>{data.referenceWebsite || "-"}</td>
                    </tr>

                    <tr>
                      <th>Attachment</th>
                      <td>
                        {data.attachment
                          ? data.attachment.name
                          : "-"}
                      </td>
                    </tr>

                    <tr>
                      <th>Additional Requirements</th>
                      <td>{data.additionalRequirement || "-"}</td>
                    </tr>

                    <tr>
                      <th>Preferred Contact</th>
                      <td>{data.contactMethod || "-"}</td>
                    </tr>

                  </tbody>
                </table>

              </div>

            </div>

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-secondary"
                onClick={this.props.prevStep}
                disabled={this.state.loading}
              >
                Previous
              </button>

              <button
                className="btn btn-success"
                onClick={this.handleSubmit}
                disabled={this.state.loading}
              >
                {this.state.loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Submitting...
                  </>
                ) : (
                  "Submit Request"
                )}
              </button>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Step8Review;